import { tabsClasses } from '@mui/material';

import { SxProp } from 'src/types/mui';

export const containerStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  height: '100%',
};

export const tabsContainerStyles: SxProp = theme => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  minHeight: 32,
  [`& .${tabsClasses.indicator}`]: {
    display: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    mx: 2,
  },
  borderRadius: 1,
  mb: 6,
});
